// extracted by mini-css-extract-plugin
export default {"warranties":"warranty_warranties__fv7p+"};